import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { SprayEventForSubmission } from 'services/sprayEventsForSubmission/types';
import { makeSelectSprayEventForSubmissionEntityName } from 'services/sprayEventsForSubmission/selectors';
import { EntityName } from 'services/entities/types';

export interface OwnProps {
    sprayEventId: SprayEventForSubmission['id'];
}

interface ConnectedProps {
    entityName?: EntityName;
}

type Props = OwnProps & ConnectedProps;

export class RenderSubmissionSprayEventsTableRowEntityNameCellComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { entityName } = this.props;

        return (
            <TableCell textAlign="left" className="events-table-cell-padding">
                {entityName}
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityName: makeSelectSprayEventForSubmissionEntityName()
});

export default connect(mapStateToProps)(
    RenderSubmissionSprayEventsTableRowEntityNameCellComponent
);
